import "./App.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Header from "./component/header.js";
import ScrollToTop from "./scrollToTop.js";
import Login from "./component/login.js";
import MainComponent from "./component/mainComponent";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  // 예전엔 "/" 로 바로 들어가도 로그인 화면을 거치지 않고 전체 관리자 화면이
  // 열렸습니다(로그인 상태를 확인하는 코드 자체가 없었습니다). 화면이 뜨기 전에
  // 먼저 서버에 "지금 로그인된 관리자가 맞는지" 물어보고, 아니라면 로그인
  // 화면으로 보냅니다.
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    let ignore = false;
    axios
      .get("/admin/auth/check")
      .then((res) => {
        if (ignore) return;
        if (!res.data?.isAdmin && location.pathname !== "/login") {
          navigate("/login");
        }
      })
      .catch(() => {
        if (!ignore && location.pathname !== "/login") {
          navigate("/login");
        }
      })
      .finally(() => {
        if (!ignore) setChecking(false);
      });
    return () => {
      ignore = true;
    };
  }, [location.pathname]);

  if (checking) {
    return null;
  }

  return (
    <div className="app_container">
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainComponent />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </div>
  );
}

export default App;
